import React, { useEffect, useState } from "react";
import {
  PageTitleComp,
  RightLayoutContainer,
  TableLayoutData,
} from "../../styledElements";
import {
  Button,
  PageHeader,
  Switch,
  Table,
  Popover,
  Avatar,
  Space,
  Tooltip,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { GlobalSet, Styled } from "../../pageStyled";
import AddEditAlertDrawer from "./AddEditAlertDrawer";
import {
  deleteCustomAlert,
  editCustomAlert,
  getAllCustomAlert,
} from "../../../Services/notifications&rolesServices";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
export default function CustomAlertsTable() {
  const condition = [
    { label: "Greater", value: ">" },
    { label: "Less", value: "<" },
    { label: "Equal", value: "=" },
    { label: "Greater and Equal", value: ">=" },
    { label: "Less and Equal", value: "<=" },
  ];
  const parameter = [
    { label: "Trim Loss", value: "trim_loss" },
    { label: "Fulfillment", value: "fulfillment" },
    { label: "Deckle Utilisation", value: "deckle_utilisation" },
    { label: "Stock %", value: "stock" },
  ];

  const channel = [
    { label: "In App", value: "in_app" },
    { label: "Email", value: "email" },
  ];

  function getLabel (array,value){
    let label = "";
    array.forEach((item)=>{
      if(item.value == value) 
        label = item.label;
    })
    return label;
  }

  const columnsHead = [
    {
      title: "Alert Name",
      dataIndex: "alertName",
      key: "alertName",
    },
    {
      title: "Parameter",
      dataIndex: "parameter",
      key: "parameter",
      render: (text) => (<span>{getLabel(parameter,text)}</span>),
    },
    {
      title: "Condition",
      dataIndex: "condition",
      key: "condition",
      render: (text) => (<span>{getLabel(condition,text)}</span>),
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
    },
    {
      title: "Recipients",
      dataIndex: "recipients",
      key: "recipients",
      render: (recipients) => {
        const content = (
          <div style={{ width: "250px" }}>
            {recipients?.map((r, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 8,
                }}
              >
                <Avatar src={r?.image} size="large" />
                <div style={{ marginLeft: 8 }}>
                  <div style={{ fontWeight: 500 }}>{r?.name}</div>
                  <div style={{ fontSize: 12, color: "#888" }}>{r}</div>
                </div>
              </div>
            ))}
          </div>
        );

        return (
          <Space>
            <span>{recipients.length}</span>
            <Popover
              content={content}
              title="Recipients"
              trigger="hover"
              placement="bottom"
            >
              <Button type="link" size="small" style={{ color: "#EA655B" }}>
                View
              </Button>
            </Popover>
          </Space>
        );
      },
    },
    {
      title: "Channel",
      dataIndex: "channel",
      key: "channel",
      render: (channels) => (
        <span>
          {channels.map((chan, index) => (
            <span key={index}>
              {`${getLabel(channel,chan)} ${(index < (channels.length - 1))?", ":""}`}
            </span>
          ))}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, record) => (
        <div className="boxFormType">
          <GlobalSet>
            <Styled
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "left",
              }}
            >
              <Switch
                checked={status}
                className="switch-new"
                onChange={(checked) => {
                  handleStatusChange(checked, record);
                }}
              />
            </Styled>
          </GlobalSet>
        </div>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="actionBtn" style={{marginInlineStart:"-22px"}}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"Edit this notification"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => {
                  setVisible(true);
                  setEdit(true);
                  setSelectedRecord(record);
                }}
              >
                <Iconmoon icon="edit" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"Delete this notification"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => {
                  handleDelete(record.key);
                }}
              >
                <Iconmoon icon="delete" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
    },
  ];
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const [allAlerts, setAllAlerts] = useState([]);
  const [visible, setVisible] = useState(false);
  const [edit, setEdit] = useState(false);
  const [reFetch, setReFetch] = useState(true);
  const [selectedRecord, setSelectedRecord] = useState({});
  const handleDelete = (key) => {
    deleteCustomAlert(key)
      .then((res) => {
        setActionToaster({
          error: false,
          msg: "Alert deleted successfully",
        });
        showToaster();
        setReFetch(true);
      })
      .catch((err) => {
        setActionToaster({
          error: true,
          msg: err?.response?.msg,
        });
        showToaster();
      });
  };
  const handleStatusChange = (checked, record) => {
    const body = {
      enable_notifications: checked,
    };
    editCustomAlert(record.key, body)
      .then((res) => {
        setActionToaster({
          error: false,
          msg: "Status updated successfully",
        });
        showToaster();
        setReFetch(true);
      })
      .catch((err) => {
        setActionToaster({
          error: true,
          msg: err?.response?.msg,
        });
        showToaster();
      });
  };
  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 2000);
  };

  useEffect(async () => {
    if (!reFetch) return;
    // const alertsData = [
    //   {
    //     key: 1,
    //     alertName: "Stock Threshold Alert",
    //     parameter: "Stock Level",
    //     condition: "<=",
    //     value: "50",
    //     recipients: [
    //       {
    //         name: "Ravi Sharma",
    //         email: "ravi@company.com",
    //         image: "https://i.pravatar.cc/40?img=1",
    //       },
    //       {
    //         name: "Anjali Verma",
    //         email: "anjali@company.com",
    //         image: "https://i.pravatar.cc/40?img=2",
    //       },
    //       {
    //         name: "Ravi Sharma",
    //         email: "ravi@company.com",
    //         image: "https://i.pravatar.cc/40?img=1",
    //       },
    //       {
    //         name: "Anjali Verma",
    //         email: "anjali@company.com",
    //         image: "https://i.pravatar.cc/40?img=2",
    //       },
    //       {
    //         name: "Ravi Sharma",
    //         email: "ravi@company.com",
    //         image: "https://i.pravatar.cc/40?img=1",
    //       },
    //       {
    //         name: "Anjali Verma",
    //         email: "anjali@company.com",
    //         image: "https://i.pravatar.cc/40?img=2",
    //       },
    //       {
    //         name: "Ravi Sharma",
    //         email: "ravi@company.com",
    //         image: "https://i.pravatar.cc/40?img=1",
    //       },
    //       {
    //         name: "Anjali Verma",
    //         email: "anjali@company.com",
    //         image: "https://i.pravatar.cc/40?img=2",
    //       },
    //     ],
    //     channel: ["In App", "Email"],
    //     status: "active",
    //   },
    //   {
    //     key: 2,
    //     alertName: "Order Approval Request",
    //     parameter: "Order Amount",
    //     condition: ">=",
    //     value: "50000",
    //     recipients: [
    //       {
    //         name: "Operations Head",
    //         email: "opshead@company.com",
    //         image: "https://i.pravatar.cc/40?img=3",
    //       },
    //     ],
    //     channel: ["In App"],
    //     status: "inactive",
    //   },
    // ];
    const start = 0;
    const end = 10;

    const allAlert = await getAllCustomAlert(start, end);
    // console.log(allAlert);
    const alertsData = allAlert?.custom_alerts?.map((alert) => ({
      key: alert.id,
      alertName: alert.name,
      parameter: alert.parameter,
      condition: alert.condition,
      value: alert.value,
      recipients: alert.recipients,
      channel: alert.channel,
      status: alert.enable_notifications,
    }));
    setAllAlerts(alertsData);
    setReFetch(false);
  }, [reFetch]);
  return (
    <RightLayoutContainer>
      <PageTitleComp>
        <PageHeader
          ghost={false}
          title="Custom Alerts"
          extra={[
            <Button
              key="1"
              className="themeBtn"
              type="primary"
              // htmlType="submit"
              onClick={() => setVisible(true)}
            >
              <Iconmoon icon="addcircle" size={14} color="#ffffff" />
              New Alert
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <TableLayoutData>
        <div className="tableDataFormat">
          <Table
            columns={columnsHead}
            dataSource={allAlerts}
            // onChange={onChange}
            // pagination={{
            //   total: allUsers.length,
            //   showTitle: false,
            //   showTotal: (total, range) =>
            //     `Showing ${range[0]}-${range[1]} of ${total} results`,
            // }}
          />
        </div>
      </TableLayoutData>
      {visible&&selectedRecord && (
        <AddEditAlertDrawer
          visible={visible}
          setVisible={setVisible}
          isEdit={edit}
          setEdit={setEdit}
          selectedRecord={selectedRecord}
          setReFetch={setReFetch}
        />
      )}
      {visibleToaster && actionToaster.error && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={actionToaster.msg}
        />
      )}
      {visibleToaster && !actionToaster.error && (
        <AlertContainer
          color="green toaster"
          icon={alertGreen}
          msg={actionToaster.msg}
        />
      )}
    </RightLayoutContainer>
  );
}
